"use strict";Object.defineProperty(exports, "__esModule", {value: true});

/* The local calendar day, e.g. "Sat Sep 26 2026". Selectors whose output
 * depends on "today" (the chat's "Today" divider) take it as an input, so
 * their memoized result is dropped when the day changes. */
 const getCurrentDayKey = (now = new Date()) => now.toDateString(); exports.getCurrentDayKey = getCurrentDayKey

 const DAY_CHANGED = 'Day changed'; exports.DAY_CHANGED = DAY_CHANGED
 const DAY_CHECK_INTERVAL_MS = 60 * 1000; exports.DAY_CHECK_INTERVAL_MS = DAY_CHECK_INTERVAL_MS

/* Dispatches DAY_CHANGED once the local day changes, so connected views
 * re-run their selectors past midnight even when nothing else is dispatched
 * (an idle chat left open overnight). It polls rather than timing midnight,
 * because timers do not run while the computer sleeps. The interval lives as
 * long as the page (one store per page load); test stores get one too, so a
 * store-backed spec must not call jest.runAllTimers(). */
 const dayRolloverMiddleware = store => {
  let day = exports.getCurrentDayKey.call(void 0, )
  setInterval(() => {
    const today = exports.getCurrentDayKey.call(void 0, )
    if (today === day) return
    day = today
    store.dispatch({ type: exports.DAY_CHANGED, payload: today })
  }, exports.DAY_CHECK_INTERVAL_MS)

  return next => action => next(action)
}; exports.dayRolloverMiddleware = dayRolloverMiddleware
